import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { isEmpty } from '@semios/app-platform-common'
import { MAP_VISUAL } from 'stores/mapControlsStore/types'
import { apiFetch } from 'utils/apiFetch'
import { unitConverter } from 'utils/unitConverter/unitConverter'
import type { TGetCacheUpdatesFromResponseParameters, TGetCacheUpdatesFromResponseReturn } from './_types'
import { generateUsualStyleAPIArgs } from './_utils/generateUsualStyleAPIArgs'
import { generateUsualStyleGetCacheUpdatesFromResponse } from './_utils/generateUsualStyleGetCacheUpdatesFromResponse'
import { getValueType } from './_utils/getValueType'

const valueGroup = 'wet_bulb'
const baseUnitConverter = unitConverter.wetBulbInCanopy
const blockValueKey = 'median_value'
const heatmapExtremesForAllPropertiesInVisibleRegions = true

const makeApiArgs = (
  processedCaches: TGetCacheUpdatesFromResponseParameters['processedCaches'],
): routes.ValuesCurrent.Request => {
  return generateUsualStyleAPIArgs({
    heatmapExtremesForAllPropertiesInVisibleRegions,
    processedCaches,
    block: {
      valueType: getValueType(MAP_VISUAL.BLOCK, valueGroup),
    },
    inBlockPoint: {
      valueType: getValueType(MAP_VISUAL.POINT, valueGroup),
    },
    property: {
      valueType: getValueType(MAP_VISUAL.PROPERTY, valueGroup),
    },
    region: {
      valueType: getValueType(MAP_VISUAL.REGION, valueGroup),
    },
  })
}

export const getResponseAndShapeForCacheUpdate = async ({
  cacheKeys,
  processedCaches,
}: TGetCacheUpdatesFromResponseParameters): Promise<TGetCacheUpdatesFromResponseReturn> => {
  const args = makeApiArgs(processedCaches)

  if (isEmpty(args)) return {}

  const response = await apiFetch({ url: '/values-current', body: args })

  return generateUsualStyleGetCacheUpdatesFromResponse({
    cacheKeys,
    heatmapExtremesForAllPropertiesInVisibleRegions,
    processedCaches,
    response,
    block: {
      decimalPlaces: 1,
      valueType: getValueType(MAP_VISUAL.BLOCK, valueGroup),
      unitConverterFunction: baseUnitConverter,
      valueKey: blockValueKey,
    },
    inBlockPoint: {
      decimalPlaces: 1,
      valueType: getValueType(MAP_VISUAL.POINT, valueGroup),
      unitConverterFunction: baseUnitConverter,
    },
    property: {
      decimalPlaces: 1,
      valueType: getValueType(MAP_VISUAL.PROPERTY, valueGroup),
      unitConverterFunction: baseUnitConverter,
    },
    region: {
      decimalPlaces: 1,
      valueType: getValueType(MAP_VISUAL.REGION, valueGroup),
      unitConverterFunction: baseUnitConverter,
    },
  })
}
